import React from 'react'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { TextField, Button } from '@mui/material';

import { useDispatch } from 'react-redux';
import { deleteChron } from '../features/chronology';


export default function DeleteChron(props) {
  
  const dispatch = useDispatch()

  const handleYes = () => {
    dispatch(deleteChron())
    props.handleClose()
  }

  const handleNo = () => {
    props.handleClose()
  }

  return (
    <Modal
      open={props.open}   
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Sei sicuro di voler cancellare la cronologia?
        </Typography>
        <div style={{float:'right'}}>
          <Button variant='contained' style={{marginRight:'15px'}} color='red' onClick={handleNo}>No</Button>
          <Button variant='contained' onClick={handleYes}>Si</Button>
        </div>
      </Box>
    </Modal>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight:'90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px'
};